import React from "react";
import { ScrollArea, Group, Code } from "@mantine/core";
import {
  IconGauge,
  IconLock,
  IconAdjustments,
  IconPhoto,
  IconPackage,
  IconBuilding,
  IconMap,
  IconCertificate,
  IconMessageCircle,
  IconShield,
  IconUsers,
  IconSettings,
  IconLayout,
  IconUserCircle,
  IconBrandFacebook,
  IconSearch,
  IconMail,
  IconPalette,
  IconFileText,
} from "@tabler/icons-react";
import { LinksGroup } from "./NavbarNested/LinksGroup";
import { UserButton } from "./NavbarNested/UserButton";
import { Logo } from "./NavbarNested/Logo";

interface AdminNavbarProps {
  closeDrawer?: () => void;
}

export function AdminNavbar({ closeDrawer }: AdminNavbarProps) {
  const navbarData = [
    { label: "Dashboard", icon: IconGauge, link: "/admin/dashboard" },
    { label: "Manage Theme", icon: IconPalette, link: "/admin/theme" },

    {
      label: "Security",
      icon: IconLock,
      links: [
        { label: "Enable 2FA", link: "/admin/security/2fa", icon: IconShield },
        {
          label: "Change Password",
          link: "/admin/security/password",
          icon: IconLock,
        },
        {
          label: "Recovery Codes",
          link: "/admin/security/recovery",
          icon: IconUsers,
        },
        {
          label: "Login History",
          link: "/admin/security/history",
          icon: IconUsers,
        },
        {
          label: "API Keys",
          link: "/admin/security/api-keys",
          icon: IconSettings,
        },
      ],
    },

    {
      label: "Manage Gallery",
      icon: IconPhoto,
      links: [
        { label: "Header", link: "/admin/gallery/header", icon: IconLayout },
        {
          label: "OurProducts",
          link: "/admin/gallery/ourproducts",
          icon: IconPackage,
        },
        {
          label: "Products",
          link: "/admin/gallery/products",
          icon: IconPackage,
        },
        {
          label: "International",
          link: "/admin/gallery/international",
          icon: IconMap,
        },
        {
          label: "Certifications",
          link: "/admin/gallery/certifications",
          icon: IconCertificate,
        },
        {
          label: "Contact Us",
          link: "/admin/gallery/contact",
          icon: IconMessageCircle,
        },
        {
          label: "About Us",
          link: "/admin/gallery/about-us",
          icon: IconBuilding,
        },
        {
          label: "Quality Process",
          link: "/admin/gallery/quality-process",
          icon: IconShield,
        },
        {
          label: "Packaging",
          link: "/admin/gallery/packaging",
          icon: IconPackage,
        },
        { label: "Hero Slides", link: "/admin/gallery/hero", icon: IconPhoto },
        { label: "Blog", link: "/admin/gallery/blog", icon: IconFileText },
      ],
    },

    {
      label: "Manage Users",
      icon: IconUsers,
      links: [
        { label: "All Users", link: "/admin/users", icon: IconUserCircle },
      ],
    },

    {
      label: "Settings",
      icon: IconAdjustments,
      links: [
        {
          label: "General",
          link: "/admin/settings/general",
          icon: IconSettings,
        },
        {
          label: "Company Info",
          link: "/admin/settings/company",
          icon: IconBuilding,
        },
        {
          label: "Social Media",
          link: "/admin/settings/social",
          icon: IconBrandFacebook,
        },
        { label: "SEO", link: "/admin/settings/seo", icon: IconSearch },
        {
          label: "Email Settings",
          link: "/admin/settings/email",
          icon: IconMail,
        },
      ],
    },
  ];

  const links = navbarData.map((item) => (
    <LinksGroup key={item.label} {...item} closeDrawer={closeDrawer} />
  ));

  return (
    <nav
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "var(--secondary-color)", 
        color: "#fff",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "16px",
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <Group justify="space-between">
          <Logo />

          <Code
            style={{
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
            }}
          >
            v1.0.0
          </Code>
        </Group>
      </div>

      {/* Links */}
      <ScrollArea style={{ flex: 1, padding: "8px" }}>
        <div
          style={{
            paddingTop: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          {links}
        </div>
      </ScrollArea>

      {/* Footer */}
      <div
        style={{
          padding: "12px",
          borderTop: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <UserButton />
      </div>
    </nav>
  );
}
